import {baseApi} from "@/api/base";
import { setToken, removeToken } from '@/utils/auth'

export class passportLogin extends baseApi{
	router="/passport";
	method="post";

	beforSuccess(response){
		setToken(response.token);
	};
}

export class passportLogout extends baseApi{
	router="/passport";
	method="delete";
	beforSuccess(response){
		removeToken();
	}
}


// WEBPACK FOOTER //
// ./src/api/passport.js